<script setup>
defineProps({
  title: { type: String, required: true },
  text: { type: String, default: '' },
})
</script>

<template>
  <div class="empty-state">
    <svg viewBox="0 0 120 74" fill="none" aria-hidden="true">
      <path d="M15 59h90M30 58V36l30-22 30 22v22M43 58V39h34v19M53 58V46h14v12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M23 26c7-2 10-7 12-14 2 7 5 12 12 14-7 2-10 7-12 14-2-7-5-12-12-14Z" fill="currentColor" opacity=".14" />
    </svg>
    <h3>{{ title }}</h3>
    <p v-if="text">{{ text }}</p>
    <slot />
  </div>
</template>
